import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';

const Accordion = withStyles({
    root: {
        border: '1px solid rgba(0,0,0,.125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
    },
    expanded: {
        margin: 'auto',
    },
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        backgroundColor: 'rgba(0,0,0,.03)',
        borderBottom: '1px solid rgba(0,0,0,.125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(props => <MuiAccordionSummary {...props} />);

AccordionSummary.muiName = 'AccordionSummary';

const AccordionDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails);


class Activities extends Component {

    state = {
        expanded: "Festivals",
        sections: [
            {
                title: "Festivals",
                renderFunction: this.renderFestivals
            },
            {
                title: "Shopping",
                renderFunction: this.renderShopping
            },
            {
                title: "Activities",
                renderFunction: this.renderActivities
            }
        ]
    };

    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    render() {
        const {expanded, sections} = this.state;

        return (
            <div>
                <p style={{width: "100%", textAlign: "center"}}>Click to expand</p>
                {
                    sections.map(sec => (
                        <Accordion
                            square
                            expanded={expanded === sec.title}
                            onChange={this.handleChange(sec.title)}
                            key={sec.title}
                        >
                            <AccordionSummary>
                                {sec.title}
                            </AccordionSummary>
                            <AccordionDetails>
                                {sec.renderFunction()}
                            </AccordionDetails>
                        </Accordion>
                    ))
                }
            </div>
        );
    }

    renderFestivals() {
        return (
            <div>
                <p><b>Gnaoua &amp; World Music Festival</b> – late June lasting 3-4 days, the best free music festival
                    anywhere! Every year thousands of foreign music lovers visit Place Moulay El-Hassan to attend this
                    spectacular festival. Up to 300 local and international musicians and singers perform on the many
                    stages that are prepared for the event – one being on the beach.</p>
                <p><b>Alizes Classical Music Festival</b> – takes place in May.</p>
                <p><b>Kite Board Pro World Tour</b> - <a href="http://www.kiteboardpro.com">www.kiteboardpro.com</a></p>
                <p><b>REGGAE 4 AFRICA Festival</b> - takes place in November</p>

            </div>
        );
    }

    renderActivities() {
        return (
            <div>
                <p>
                    The following activities can be done by the hour, day or however long you wish. We can
                    organise this for you - Kite-surfing, Quad Biking, Windsurfing, Surfing, Camel Riding,
                    Horse Riding along the beach, Bike hire is available from Bab Marrakech, &amp; Drumming
                    lessons.
                </p>
                <p>
                    The local bus operates from Bab Doukkala with services to Sidi Kaoki, Tidzi and Hedra.
                </p>
                <p>
                    <b>Moroccan cuisine</b> - Morocco is renowned for its cous cous and tagine dishes and
                    there are many restaurants to visit and some have traditional Moroccan dancing in the
                    evenings.
                </p>
                <p>
                    <b>Beach</b> - The magnificent white sand beach stretches as far as the eye can see
                    around the bay which is famous for providing great windsurfing conditions and a paradise
                    for surfers and divers.
                </p>
                <p>
                    <b>Sidi Mohammed Ben Abdellah Museum</b> - Since 1981, the former pasha’s residence is
                    now a Museum which displays a large collection of objects from both the city and its
                    region. Old weapons, jewellery and musical instruments and marquetry which reveal many
                    aspects of the history and culture of the city and its people.
                </p>
                <p>
                    <b>Art</b> - Essaouira is the hub of contemporary Moroccan art, with such artists as
                    Nurredin Alioua, Mohammed Tabal and Mohammed Bouada. There are many art galleries in and
                    around the winding streets of the medina.
                </p>
                <p>
                    <b>Skala du Port</b> - you can visit but there is a small charge for entrance.
                </p>
                <p>
                    <b>Olive Oil</b> - Excursions can be arranged to visit the local olive oil co-operative
                    at Tidzi or the Sunday market at Hedra.
                </p>
                <p>
                    <b>Winery</b> - At the entrance to Ounagha, there is a winery open to visitors.
                </p>
                <p>
                    <b>Golf</b> - There is a new 18 hole golf course recently opened in Essaouira for more
                    information see - <a href="http://www.golfdemogador.com/">golfdemogador.com</a>
                </p>
            </div>
        );
    }

    renderShopping() {
        return (
            <div>
                <p>We are happy to give you guided tours around the medina and souks where there are many hand made
                    gifts available. Carving workshops where local craftsmen produce beautiful marquetry pieces from the
                    local thuya trees – a mahogany like hardwood. Fine silks and wools are utilized to create beautiful
                    carpets and intricate embroidered traditional clothing like the Jellaba. Handmade leather slippers,
                    shoes and leather bags. Local craftsmen making silvery jewellery at the Silver Market. Local
                    Moroccan cookery classes can be arranged.</p>
                <p><b>The Silver Market</b> – just a 5 minute walk from the Riad, a fantastic authentic silver market
                    where you can have distinctive and individual pieces made to your own design by local craftsmen.</p>
                <p><b>The Fish Market</b> - outside the city walls are open-air seafood stalls where an array of freshly
                    caught fish can be barbecued, grilled and served immediately. A perfect place to eat.</p>
                <p><b>Other local markets include</b> - spice market, grain market, vegetable market and flea market.
                </p>
            </div>
        );
    }
}

export default Activities

